module.exports=function(scope){ return `<li class="mdl-list__item asseco-window-chat-agent-message">
    <span class="mdl-list__item-primary-content">
        <i class="material-icons mdl-list__item-icon">${scope.agentIcon}</i>
        <span style="width: 100%;">${scope.message}</span>
    </span>
    <span class="asseco-window-chat-message-time">${scope.time}</span>
</li>`};